export default "__VITE_ASSET__71306141__"